import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@mui/material";
import React from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { styled } from "@mui/system";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "&.MuiDialog-paper": {
    borderRadius: 12,
  },
}));

const CommonDialog = ({
  open,
  setOpen,
  handleCancel,
  handleDone,
  title,
  subTitle,
  leftButtonText,
  rightButtonText,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // sx={{ borderRadius: "12px" }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          color: "#a50218",
          fontFamily: "Montserrat",
          padding: "32px 32px 12px 32px",
          fontWeight: 600,
        }}
      >
        {title || ""}
      </DialogTitle>
      <DialogContent sx={{ minWidth: "600px", padding: "20px 32px" }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontSize: "14px", fontFamily: "Montserrat", fontWeight: 500 }}
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
        {/* {subTitle || ""}
        </DialogContentText> */}
        <Divider sx={{ height: "0.5px", marginTop: "20px" }} />
      </DialogContent>
      <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
        <Box>
          <ButtonCta1
            text={leftButtonText}
            variant="contained"
            onClick={handleCancel}
            bgColor="#e0e0e0"
            color="#5a5a5a"
          />
        </Box>
        <Box style={{ marginLeft: "20px" }}>
          <ButtonCta1
            text={rightButtonText}
            variant="contained"
            onClick={handleDone}
            autoFocus
            bgColor="#a50218"
            color="#fff"
          />
        </Box>
      </DialogActions>
    </CustomDialog>
  );
};

export default CommonDialog;
